<template>
  <div class="page-news">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}`">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/council`"
          >理事会信息</el-breadcrumb-item
        >
        <el-breadcrumb-item>理事会风采</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content news-content">
        <div class="left">
          <side-nav :data="councilInfoList"></side-nav>
        </div>
        <div class="right">
          <column-header2 :data="metaData"></column-header2>
          <user-list :data="userList"></user-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from "_c/SideNav";
import ColumnHeader from "_c/ColumnHeader2";
import UserList from "./components/UserList";
import { mapState } from "vuex";

export default {
  data() {
    return {
      metaData: {
        name: "理事会风采"
      },
      userList: []
    };
  },
  computed: {
    ...mapState("college", ["councilInfoList", "collegeData"])
  },
  created() {
    this.init();
  },
  components: {
    [SideNav.name]: SideNav,
    [ColumnHeader.name]: ColumnHeader,
    [UserList.name]: UserList
  },
  methods: {
    init() {
      const linkDecorator = item => {
        item.link = this.$subsitePrefix + "/council/detail/" + item.Id;
        return item;
      };
      if (!this.collegeData.council || !this.collegeData.council.Shows) {
        this.$router.push(this.$subsitePrefix);
        return;
      }
      this.userList = this.collegeData.council.Shows.map(linkDecorator);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-news {
  background: #f6f6f9;
  padding-bottom: 40px;
  .news-content {
    padding: 16px 0 40px 0;
    display: flex;
    justify-content: space-between;
    ::v-deep .comp-column-header {
      padding: 16px 0 32px 0;
    }
    ::v-deep .comp-user {
      margin-right: 72px;
    }
    .left {
      width: 200px;
      margin-right: 24px;
    }
    .right {
      flex: 1;
    }
  }
}
</style>
